<template>
    <v-data-table
        :headers="headers"
        :items="data"
        hide-default-footer
        class="occurrence-observation-table"
    >
        <template slot="item" slot-scope="props">
            <tr :data-id="props.item.ID">
                <td class="first-column">{{props.item.Name}}</td>
                <td>{{props.item.Total}}</td>
            </tr>
        </template>
        <template slot="no-data">
            <v-alert outlined :value="true" type="info">
                No results found
            </v-alert>
        </template>
    </v-data-table>    
</template>

<style>
    .first-column { 
        width: 80%;
    }

    /* stop the rows from having so much space in them - note that the dense prop for v-data-table is available in an updated version of Vuetify that would also achieve this */
    #app .occurrence-observation-table td,
    #app .occurrence-observation-table th {
        padding-top: 5px;
        padding-bottom: 5px;
        height: 100%;
    }

    /* put a border around the outside of the table */
    #app .occurrence-observation-table table {
        border: 1px solid rgba(0,0,0,0.12);
    }

    /* make the table headers a little more obvious */
    #app .occurrence-observation-table th {
        font-weight: bold;
        color: black;
    }
</style>

<script>

export default {
    components: {
        
    },
    props: [
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "firstColumnHeader",
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "data"
    ],
    data() {
        return {
            
        };
    },
    computed: {
        headers() {
            return [
                {
                    text: this.firstColumnHeader,
                    value: this.firstColumnHeader,
                    sortable: false
                },
                {
                    text: "Total",
                    value: "Total",
                    sortable: false
                },
            ];
        }
    },
    methods: {
        
    },
    created() {
        
    },
    watch: {
        
    }
};
</script>